import { Grid } from "@mui/material";
import { UseFormReturn } from "react-hook-form";

import {
  ESTADOS_LLAMADAS_CHOICE,
  EstadosLlamadaEnumChoice,
  gridSizeMdLg6,
  parentescoMockupData,
  texto,
} from "@/shared";
import {
  CustomAutocomplete,
  CustomAutocompleteArrString,
  CustomTabPanel,
  CustomTextArea,
  CustomTextField,
  TabTextLabel,
} from "@/shared/components/ui";
import CustomCellphoneTextField from "@/shared/components/ui/CustomCellphoneTextField";
import { Agendamiento, IPreagendamiento } from "@/shared/interfaces";
import { SaveFormDataPreagendamiento } from "../../interface/SaveFormDataPreagendamiento";

export type PreagendaProspectoDataFormTabProps = {
  form: UseFormReturn<SaveFormDataPreagendamiento>;
  index: number;
  value: number;
  shrink?: boolean;
  preagendamiento: Omit<IPreagendamiento, "prospecto_data" | "preventa_data">;
  agendamiento?: Agendamiento;
  isCorrectingData?: boolean;
};

const PreagendaProspectoDataFormTab: React.FC<
  PreagendaProspectoDataFormTabProps
> = ({ form, index, value, shrink = true, isCorrectingData = false }) => {
  ///* from --------------------
  const { errors } = form?.formState;

  return (
    <CustomTabPanel index={index} value={value}>
      <TabTextLabel text="Personal Info" />

      {/* =========== personal info =========== */}
      <>
        <CustomTextField
          name="tipo_identificacion"
          label="Tipo de Identificación"
          control={form.control}
          defaultValue={form.getValues().tipo_identificacion || ""}
          error={errors.tipo_identificacion}
          helperText={errors.tipo_identificacion?.message?.toString() ?? ""}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        />
        <CustomTextField
          name="identificacion"
          label="No. Identificación"
          control={form.control}
          defaultValue={form.getValues().identificacion || ""}
          error={errors.identificacion}
          helperText={errors.identificacion?.message?.toString() ?? ""}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        />
        <CustomTextField
          name="razon_social"
          label="Nombre"
          control={form.control}
          defaultValue={form.getValues().razon_social || ""}
          error={errors.razon_social}
          helperText={errors.razon_social?.message?.toString() ?? ""}
          shrink={shrink}
          disabled
        />
      </>

      <>
        {/* ============ persona referencia ============ */}
        <>
          <CustomTextField
            name="persona_referencia_nombre"
            label="Persona de Referencia"
            control={form.control}
            defaultValue={form.getValues().persona_referencia_nombre || ""}
            error={errors.persona_referencia_nombre}
            helperText={errors.persona_referencia_nombre?.message}
            shrink={shrink}
            disabled={isCorrectingData}
          />
          {/* <CustomSelectTextField<IParentesco>
              label="Parentesco Referencia"
              defaultValue={form.getValues().persona_referencia_parentesco || ''}
              // options
              options={parentescoMockupData || []}
              labelKey="nombre"
              valueKey="nombre"
              menuItemKey="nombre"
              // errors
              register={form.register().persona_referencia_parentesco}
              error={errors.persona_referencia_parentesco}
              helperText={errors.persona_referencia_parentesco?.message}
              size={gridSizeMdLg6}
              disabled={isCorrectingData}
            /> */}

          <CustomAutocomplete<any>
            size={gridSizeMdLg6}
            label={texto.tipo_parentesco}
            name="persona_referencia_parentesco"
            options={parentescoMockupData || []}
            valueKey="nombre" // name is the fk
            defaultValue={form.getValues().persona_referencia_parentesco || ""}
            isLoadingData={false}
            control={form.control}
            error={errors.persona_referencia_parentesco}
            helperText={errors.persona_referencia_parentesco?.message}
          />

          <CustomCellphoneTextField
            name="persona_referencia_celular"
            label="Celular Persona Referencia"
            control={form.control}
            defaultValue={form.getValues().persona_referencia_celular || ""}
            error={errors.persona_referencia_celular}
            helperText={errors.persona_referencia_celular?.message}
            shrink={shrink}
            size={gridSizeMdLg6}
            disabled={isCorrectingData}
          />
        </>
      </>

      {/* <TabTextLabel text="Datos de Venta" /> */}

      {/* =========== Datos de Venta =========== */}
      {/* <>
            <CustomTextField
              name="vendedor_data.razon_social"
              label="Nombre de Vendedor"
              control={form.control}
              defaultValue={form.getValues()?.vendedor_data?.razon_social || ''}
              error={errors.vendedor_name}
              helperText={errors.vendedor_name?.message?.toString() ?? ''}
              shrink={shrink}
              size={gridSizeMdLg6}
              disabled
            />
            <CustomTextField
              name="supervisor_data.razon_social"
              label="Supervisor"
              control={form.control}
              defaultValue={form.getValues()?.supervisor_data?.razon_social || ''}
              error={errors?.supervisor?.username}
              helperText={errors.supervisor?.message?.toString() ?? ''}
              shrink={shrink}
              size={gridSizeMdLg6}
              disabled
            />
            <CustomTextField
              name="canal_venta_create"
              label="Canal de venta"
              control={form.control}
              defaultValue={form.getValues()?.canal_venta_create || ''}
              error={errors?.canal_venta_create}
              helperText={errors?.canal_venta_create?.message?.toString() ?? ''}
              shrink={shrink}
              size={gridSizeMdLg12}
              disabled
            />
          </> */}

      <>
        {/* <CustomTextField
          name="tipo_contrato"
          label="Tipo de Contrato"
          control={form.control}
          defaultValue={form.getValues().tipo_contrato || ''}
          error={errors.tipo_contrato}
          helperText={errors.tipo_contrato?.message?.toString() ?? ''}
          shrink={shrink}
          // size={gridSizeMdLg6}
          disabled
        /> */}
        {form.getValues().vendedor_name ? (
          <CustomTextField
            name="vendedor_name"
            label="Venta realizada por"
            control={form.control}
            defaultValue={form.getValues().vendedor_name || ""}
            error={errors.vendedor_name}
            helperText={errors.vendedor_name?.message?.toString() ?? ""}
            shrink={shrink}
            size={gridSizeMdLg6}
            disabled
          />
        ) : null}
        <Grid item {...gridSizeMdLg6}></Grid>
        {/* <Grid item container {...gridSizeMdLg6} alignItems="center">
          <Grid item xs={11}>
            <CustomTextField
              name="es_referido"
              label="Es referido"
              control={form.control}
              defaultValue={form.getValues().es_referido || ''}
              error={errors.es_referido}
              helperText={errors.es_referido?.message?.toString() ?? ''}
              shrink={shrink}
              disabled
            />
          </Grid>

          <Grid item xs={1}>
            <SingleIconButton
              label="Ver detalle"
              startIcon={<VisibilityIcon />}
              onClick={() => {
                setIsOpenModalReferido(true);
              }}
            />
          </Grid>
        </Grid> */}

        {/* =========== estado llamada =========== */}
        <>
          <TabTextLabel
            text="ESTADO DE LA LLAMADA"
            variant="subtitle2"
            uppercase={false}
            pb="12px"
            pt="45px"
          />

          <CustomCellphoneTextField
            name="celular"
            label="Celular Cliente"
            control={form.control}
            defaultValue={form.getValues().celular || ""}
            error={errors.celular}
            helperText={errors.celular?.message}
            shrink={shrink}
            size={gridSizeMdLg6}
            disabled={isCorrectingData}
          />
          <CustomCellphoneTextField
            name="celular_2"
            label="Celular 2 Cliente"
            control={form.control}
            defaultValue={form.getValues().celular_2 || ""}
            error={errors.celular_2}
            helperText={errors.celular_2?.message}
            shrink={shrink}
            size={gridSizeMdLg6}
            disabled={isCorrectingData}
          />
          {/* <CustomTextField
            name="email"
            label="Email Cliente"
            control={form.control}
            defaultValue={form.getValues().email || ''}
            error={errors.email}
            helperText={errors.email?.message}
            type="email"
            shrink={shrink}
            disabled={isCorrectingData}
          /> */}

          {/* --------- estado llamada --------- */}
          <CustomAutocompleteArrString
            label="Estado de la llamada"
            name="estado_llamada"
            control={form.control}
            defaultValue={form.getValues().estado_llamada || ""}
            options={ESTADOS_LLAMADAS_CHOICE.filter(
              (el) => el !== EstadosLlamadaEnumChoice.EN_ESPERA
            )}
            isLoadingData={false}
            error={errors.estado_llamada}
            helperText={errors.estado_llamada?.message}
            disableClearable
            disabled={isCorrectingData}
          />
          <CustomTextArea
            label="Observación Llamada"
            name="observacion_llamada"
            control={form.control}
            defaultValue={form.getValues().observacion_llamada || ""}
            error={errors.observacion_llamada}
            helperText={errors.observacion_llamada?.message}
            required={false}
            disabled={isCorrectingData}
          />
        </>
      </>

      {/* ================== MODALS ================== */}
      {/* <ReferidoPreagendamientoModal
        isOpen={isOpenModalReferido}
        onClose={() => setIsOpenModalReferido(false)}
        tipoReferido={form.getValues().tipo_referido || ''}
        referido_cliente_data={preagendamiento?.referido_cliente_data}
        referido_flota_data={preagendamiento?.referido_flota_data}
      /> */}
    </CustomTabPanel>
  );
};

export default PreagendaProspectoDataFormTab;
